import axios from 'axios'
import { API_URL } from '../../../../setup/config/env'

export function getAiNews(query) {
    return dispatch => {
        return axios.get(`${API_URL}/api/seo/news`, { params: { q: query } })
    }
}

export function generateBlogFromNews(newsData) {
    const currentUser = (() => { try { return JSON.parse(localStorage.getItem('user') || '{}'); } catch(e) { return {}; } })();
    const email = currentUser.email || '';
    const payload = { ...newsData, email };
    return dispatch => {
        return axios.post(`${API_URL}/api/seo/news/generate-blog`, payload)
    }
}

export function uploadThumbnail(file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', 'cms');
    return dispatch => {
        return axios.post(`${API_URL}/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
}
